export default __webpack_public_path__ + "static/media/bannerHome2.aea9dca9.jpg";